import { render, staticRenderFns } from "./ModelPreview.vue?vue&type=template&id=b22fbb28"
import script from "./ModelPreview.vue?vue&type=script&lang=js"
export * from "./ModelPreview.vue?vue&type=script&lang=js"
import style0 from "./ModelPreview.vue?vue&type=style&index=0&id=b22fbb28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports